import Vue from 'vue';

Vue.component('hub-settings-index', () =>
    import(/* webpackChunkName: 'hub-settings-index' */ './hub-settings-index'),
);

Vue.component('hub-settings-detail', () =>
    import(/* webpackChunkName: 'hub-settings-detail' */ './hub-settings-detail'),
);

Vue.component('hub-settings-edit', () =>
    import(/* webpackChunkName: 'hub-settings-edit' */ './hub-settings-edit'),
);

Vue.component('hub-settings-global-edit', () =>
    import(/* webpackChunkName: 'hub-settings-global-edit' */ './hub-settings-global-edit'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/hub-settings/index.js